module.exports = __webpack_public_path__ + "media/custom/images/pocstock-about-us-collage-1-cb2fadbecef73d4e33b93c588044944d.png";